module.exports = __webpack_public_path__ + "img/second.5881393c.jpg";